import { render, staticRenderFns } from "./edicao_usuario_prefeitura.vue?vue&type=template&id=65097b34&scoped=true&"
import script from "./edicao_usuario_prefeitura.vue?vue&type=script&lang=js&"
export * from "./edicao_usuario_prefeitura.vue?vue&type=script&lang=js&"
import style0 from "./edicao_usuario_prefeitura.vue?vue&type=style&index=0&id=65097b34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65097b34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VRadio,VRadioGroup,VSelect,VTextField})
